/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=Symbol("idFieldsProviderSymbol");function o(o){return!!o&&n in o}function i(i){return o(i)?i[n]:void 0}export{i as getIdFieldsProvider,n as idFieldsProviderSymbol};
